module.exports = __webpack_public_path__ + "b0fd5e10c0f172cd3cb36b93dda2d585.svg";